import { useEffect, useState } from "react";

const TestimonialCarousel = ({testimonials} :any) => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive((prev) => (prev + 1) % testimonials.length);
    }, 6000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* Card */}
      <div className="relative bg-white border border-gray-200 rounded-[40px] p-8 shadow-sm transition-all">
        <p className="text-[#0c0407] text-base md:text-lg leading-relaxed mb-6">
          {testimonials[active].text}
        </p>

        <div className="text-md text-[#0c0407] font-semibold">
          {testimonials[active].author}
          <span className="font-normal text-[#0c0407]">
            {" "} | {testimonials[active].role}
          </span>
        </div>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-8">
        {testimonials.map((_:any, index:any) => (
          <button
            key={index}
            onClick={() => setActive(index)}
            className={`w-4 h-4 rounded-full transition ${
              active === index ? "bg-[#fa0053]" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </>
  );
};

export default TestimonialCarousel;